import { Cell, Gutter } from '@adserve/adserve-react-components';
import React, {useContext } from 'react';
import { InputNumberCell } from '../../../generic/AsTable/Standard';
import { tableCellStyle } from '../CampaignBriefStyles';
import moment from 'moment';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';

const valueColumnsStyle = {
    ...tableCellStyle,
    justifyContent: 'flex-start',
    paddingLeft: 10
};

const WeeklyBudgetDataRow = ({
    entity = {},
    index,
    scrollPx,
    onScroll,
    scrollableLength = 0,
    onHover,
    isHighlighted,
    onChange,
    rowHeight,
    visibleRows,
    readOnly,
    hideEditable = false
}) => {
    const { dateFormat } = useContext(SystemSettingsContext);
    const maxVisibleLength = rowHeight * visibleRows;

    /**
     * mouseEnter event handler for all cells in this row
     * used for row highlighting and dragging
     * @param {Event} event - event
     */
    const onMouseEnter = (event) => {
        typeof onHover === 'function' && onHover(index);
    };

    /**
     * mouseLeave event handler for all cells in this row
     * @param {Event} event - event
     */
    const onMouseLeave = (event) =>
        typeof onHover === 'function' && onHover(-1);

    const onNumberChange = (event) => {
        onChange({ ...entity, value: event.target.value });
    };

    return (
        <>
            <Cell
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{ ...tableCellStyle, borderWidth: '0 1px 1px 1px' }}
            >
                {entity.key ? index + 1 : ''}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={tableCellStyle}
            >
                {entity.key
                    ? moment(entity.key).format(`${dateFormat}`)
                    : ''}
            </Cell>
            {hideEditable ? (
                <Cell
                    rowHeight={rowHeight}
                    scrollPx={scrollPx}
                    index={index}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    isHighlighted={isHighlighted}
                    visibleRows={visibleRows}
                    style={valueColumnsStyle}
                >
                    {entity.value
                        ? `${entity.value}`
                        : ''}
                </Cell>
            ) : (
                <InputNumberCell
                    rowHeight={rowHeight}
                    scrollPx={scrollPx}
                    index={index}
                    value={entity.value}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    isHighlighted={isHighlighted}
                    visibleRows={visibleRows}
                    onChange={onNumberChange}
                    disabled={readOnly}
                    inputStyle={tableCellStyle}
                />
            )}
            {index === 0 && (
                <Gutter
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    index={index}
                    maxVisibleLength={maxVisibleLength}
                    scrollableLength={scrollableLength}
                    onScroll={onScroll}
                ></Gutter>
            )}

            {index >= visibleRows && <div></div>}
        </>
    );
};

export default WeeklyBudgetDataRow;
